import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { PaginationContainer, PaginationWrapper, PaginationExtraContainer, } from "./pagination.styles";
import { StyledButton } from "./button.styles";
import { SimplePaginationItem } from "../simple-pagination-item";
import { PaginationItem } from "../pagination-item";
import { Indicator } from "../indicator/indicator";
import { Dropdown } from "../dropdown/dropdown";
import { handleComplexPagination } from "./utils";
const basicMaxPages = 7;
const basicMaxPagesMobile = 4;
export function Pagination({ totalItems, type = "simple", defaultActivePage = 1, pageSizeOptions = [10, 20, 50, 100], onPageChange, onFilterChange, showIndicator, showPagesFilter, indicatorLabel = "page", pagesFilterLabel = "items", previewId, }) {
    const [currentPage, setCurrentPage] = useState(defaultActivePage);
    const [customPage, setCustomPage] = useState(undefined);
    const [perPageItems, setPerPageItems] = useState(pageSizeOptions[0]);
    const [isMobile, setMobile] = React.useState(false);
    const [base, setBase] = useState(4);
    const pagesCount = Math.ceil(totalItems / perPageItems);
    useEffect(() => {
        if (window.matchMedia("(pointer: coarse)").matches ||
            window.matchMedia("(max-width: 320px)").matches) {
            setBase(3);
            setMobile(true);
        }
    }, []);
    function renderSimplePaginationItems() {
        return (_jsx(SimplePaginationItem, { onChange: (page) => {
                setCustomPage(page || -1);
            }, onEnter: () => {
                if (customPage > 0 && customPage <= pagesCount) {
                    setCurrentPage(customPage);
                }
                else if (!customPage) {
                    setCurrentPage(1);
                }
                else {
                    setCurrentPage(pagesCount);
                }
                setCustomPage(undefined);
            }, step: customPage === -1 ? " " : customPage || currentPage, totalItems: pagesCount }));
    }
    function renderPaginationItems() {
        const totalItemsArray = Array.from(Array(pagesCount).keys()).map((_, i) => i + 1);
        let items = totalItemsArray;
        if (pagesCount > (isMobile ? basicMaxPagesMobile : basicMaxPages)) {
            items = handleComplexPagination(base, pagesCount, currentPage, totalItemsArray, isMobile);
        }
        return items.map((e, index) => (_jsx(PaginationItem, { onSelect: () => {
                let offset = e === -1 ? currentPage + (base + 1) : currentPage - (base + 1);
                offset = Math.min(offset, pagesCount);
                offset = Math.max(offset, 1);
                const nextPage = e > 0 ? e : offset;
                if (onPageChange) {
                    onPageChange(nextPage);
                }
                setCurrentPage(nextPage);
                setCustomPage(nextPage);
            }, step: e, direction: e === -1 ? "right" : "left", active: e === currentPage }, String(index))));
    }
    function renderItems() {
        if (type === "simple") {
            return renderSimplePaginationItems();
        }
        return renderPaginationItems();
    }
    return (_jsxs(PaginationWrapper, Object.assign({ "data-preview-id": previewId }, { children: [_jsxs(PaginationContainer, { children: [_jsx(StyledButton, { disabled: currentPage === 1, onClick: () => {
                            let nextPage = currentPage - 1;
                            if (customPage && currentPage !== customPage) {
                                nextPage = customPage;
                            }
                            if (onPageChange) {
                                onPageChange(nextPage);
                            }
                            setCurrentPage(nextPage);
                            setCustomPage(nextPage);
                        }, buttonType: "button", isIcon: true, symbol: "ChevronLeft", stylingType: "flat" }), renderItems(), _jsx(StyledButton, { disabled: currentPage === pagesCount, onClick: () => {
                            let nextPage = currentPage + 1;
                            if (customPage && currentPage !== customPage) {
                                nextPage = customPage;
                            }
                            if (onPageChange) {
                                onPageChange(nextPage);
                            }
                            setCurrentPage(nextPage);
                            setCustomPage(nextPage);
                        }, buttonType: "button", isIcon: true, symbol: "ChevronRight", stylingType: "flat" })] }), _jsxs(PaginationExtraContainer, { children: [showPagesFilter && (_jsx(Dropdown, { indicatorLabel: indicatorLabel, onChange: (perPagesItems) => {
                            const getNextPage = () => {
                                const total = currentPage * perPageItems;
                                let nextPage = 1;
                                let counter = 0;
                                while (!nextPage && counter < 100) {
                                    if (counter * perPagesItems === total) {
                                        nextPage = counter;
                                    }
                                    counter += 1;
                                }
                                return nextPage;
                            };
                            const nextPage = getNextPage();
                            if (onPageChange) {
                                onPageChange(nextPage);
                            }
                            if (onFilterChange) {
                                onFilterChange(perPagesItems);
                            }
                            setCustomPage(nextPage);
                            setCurrentPage(nextPage);
                            setPerPageItems(perPagesItems);
                        }, items: pageSizeOptions.map((o) => ({
                            id: String(o),
                            value: String(o),
                            text: `${String(o)} / page`,
                        })) })), showIndicator && (_jsx(Indicator, { totalItems: totalItems, currentPage: currentPage, perPageItems: perPageItems, pagesFilterLabel: pagesFilterLabel }))] })] })));
}
